module.exports = __webpack_public_path__ + "img/tuna-pasta-un-casserole.68ccb0b2.jpg";